export const SET_INPUT_VALUE_FOR_CREATE_STUDENT_FORM = 'SET_INPUT_VALUE_FOR_CREATE_STUDENT_FORM';
export const setInputValueForCreateStudentForm = data => ({
  type: SET_INPUT_VALUE_FOR_CREATE_STUDENT_FORM,
  payload: data,
});
